import React from 'react';
import PropTypes from 'prop-types';
import usePastOffersForUser from '../usePastOffersForUser';
import SectionHeader from '../../../components_profiles/SectionHeader';
import Offer from '../../offers/Offer';
import Loader from '../../../components/Loader';
import useShowMorePagination from '../shared/useShowMorePagination';
import useStableList from '../shared/useStableList';
import ShowMoreButton from '../shared/ShowMoreButton';

PastOffers.propTypes = {
  user: PropTypes.object.isRequired
};

export default function PastOffers(props) {
  const { user } = props;

  const { showAll, showMore, page, pageSize } = useShowMorePagination();
  const pastOffersRes = usePastOffersForUser(user, { page, pageSize });
  const { data, isFetching, meta } = useStableList(pastOffersRes);

  const offersCount = data.length;
  const totalCount = (meta && meta.totalCount) || 0;
  const totalExtra = Math.max(0, totalCount - offersCount);

  function handleShowMore() { showMore(); }

  if (offersCount > 0) {
    return (
      <div className="space-y-4">
        <SectionHeader
          title="Past Offers"
          subtitle="Experiences I have offered to educators in the past."
        />
        <div className="grid grid-cols-1 gap-4">
          {data.map(function(offer) {
            return (
              <Offer
                key={offer.id || offer.cid}
                offer={offer}
              />
            );
          })}
          {totalExtra > 0 && !showAll && (
            <ShowMoreButton count={totalExtra} onClick={handleShowMore} disabled={isFetching} noun="offers" />
          )}
          {isFetching && <Loader />}
        </div>
      </div>
    );
  }

  return null;
}
